// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"MY-z","subtitle":"NY-z","wrapper":"OY-z","leftArrow":"PY-z","rightArrow":"QY-z"};